import { WindowLocation } from '@reach/router'
import { mapIndexed } from 'rambdax'

import ZoneHomeBoxes, {
  ZoneHomeBoxesProps,
} from '@algbra/ui/zones/HomeBoxes/HomeBoxes'
import ZoneSpotlightHeader, {
  ZoneSpotlightHeaderProps,
} from '@algbra/ui/zones/SpotlightHeader/SpotlightHeader'

import ZoneNewsList, { ZoneNewsListProps } from '../zones/News/NewsList'

export type ZoneItemType =
  | ZoneHomeBoxesProps
  | ZoneSpotlightHeaderProps
  | ZoneNewsListProps

export type ZoneRendererProps = {
  zones: ZoneItemType[]
  location: WindowLocation<{ value: string }>
}

export function getComponentByZoneType(
  zone: ZoneItemType,
  key: string,
  location?: WindowLocation<{ value: string }>
) {
  switch (zone.__typename) {
    case 'StrapiGQL_ComponentZonesHomeBoxes':
      return <ZoneHomeBoxes key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesSpotlightHeader':
      return <ZoneSpotlightHeader key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesNews':
      return <ZoneNewsList key={key} {...zone} />

    default:
      return null
  }
}
export default function CorporateHomeZoneRenderer({
  zones,
  location,
}: ZoneRendererProps) {
  return (
    <main>
      {mapIndexed(
        (zone, index) =>
          getComponentByZoneType(zone, `${zone.__typename}-${index}`, location),
        zones
      )}
    </main>
  )
}
